<mat-sidenav-container>
    <mat-sidenav #sidenav class="mat-elevation-z8" mode="side" opened>
        @if (sidenav.opened) {
            <div class="top-right-nav-toggle">
                <button (click)="sidenav.toggle()" color="primary" mat-icon-button>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        }
        <div>

            @if (assetUrl$ | async) {
                <div>
                    <div class="sidenav-info">
                        <valumize-logo-finder [companyDomain]="(assetUrl$ | async) ?? ''"></valumize-logo-finder>
                    </div>
                </div>
            }
            <div class="sidenav-info">
                @if (reportDate$ | async; as reportDate) {
                    <ng-container class="report-date">
                        @if (!!reportDate.date) {
                            <div>
                                <div>
                                    <label data-test="report-date-label">Report Date</label>
                                    <p data-test="report-date">{{ reportDate | traceableFormat }}</p>
                                </div>
                                @if ((sourceDataset$ | async) === 'master') {
                                    @if (closingDate$ | async; as closingDate) {
                                        @if (!!closingDate.date) {
                                            <div style="display: flex">
                                                <div>
                                                    <label data-test="closing-date-label">Closing Date</label>
                                                    <p data-test="closing-date">{{ closingDate | traceableFormat }}</p>
                                                </div>
                                            </div>
                                        } @else {
                                            Asset valuation can only be added if a fund valuation is selected first!
                                        }
                                    }
                                    @if ((selectedPreferredValuation$ | async); as selectedAssetValuation; ) {
                                        <div>
                                            <label>Final Bid Price</label>
                                            <p>{{ selectedAssetValuation.finalBidPrice | traceableFormat }}</p>
                                        </div>
                                        <div>
                                            <label>Discount to GP NAV</label>
                                            <p>{{ selectedAssetValuation.discountToGpNAV | traceableFormat }}</p>
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </ng-container>
                }
            </div>
            <mat-divider></mat-divider>
            @if ((sourceDataset$ | async) !== 'master') {
                <div class="sidenav-info">
                    <h3>Merge Target</h3>
                </div>
                <div class="sidenav-info">
                    <div>
                        <div class="label-search">
                            <label>Selected Company</label>
                            <button (click)="displaySearch()"
                                    color="primary"
                                    data-test="search-merge-target-button"
                                    mat-icon-button>
                                <mat-icon>search</mat-icon>
                            </button>
                        </div>
                        @if (searchEnabled) {
                            <valumize-search
                                (searchResultSelected)="selectMergeTarget($event)"
                                [searchCategories]="['assets']"
                                [showSearchIcon]="false"
                                [targetSearch]="true">
                            </valumize-search>
                        }
                        @if (baselineAssset$ | async; as baselineAsset) {
                            <div class="selected-asset">
                                <p class="selected-asset-name">{{ baselineAsset.data.name | traceableFormat }}</p>
                                @if (baselineAsset.data.id) {
                                    <button (click)="deselectAssetMergeTarget()"
                                            color="primary"
                                            data-test="cancel-button"
                                            mat-icon-button>
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                }
                            </div>
                            @if (baselineAsset.data.id && (selectedFundReportMergeTargetId$ | async) !== null) {
                                <div class="warning-message" matTooltip="Merging will replace baseline data with the selected asset’s values.">
                                    <mat-icon class="warning-icon" color="warn">warning</mat-icon>
                                    <span>This will merge and overwrite the baseline asset with the selected one.</span>
                                </div>
                            }
                        }
                    </div>
                </div>
                <mat-divider></mat-divider>
            }
            <mat-action-list>
                @if ((sourceDataset$ | async) === 'master') {
                    <a (click)="scrollToComponent('description')" data-test="company-description-nav-item">
                        <mat-list-item>Company Description</mat-list-item>
                    </a>
                    <a (click)="scrollToComponent('news')" data-test="news-nav-item">
                        <mat-list-item>News</mat-list-item>
                    </a>
                }
                <a (click)="scrollToComponent('general-information')" data-test="general-information-nav-item">
                    <mat-list-item>General Information</mat-list-item>
                </a>
                @if ((sourceDataset$ | async) === 'master') {
                    <a (click)="scrollToComponent('end-markets-customers')" data-test="end-markets-nav-item">
                        <mat-list-item>End Markets</mat-list-item>
                    </a>
                    <a (click)="scrollToComponent('swot')" data-test="swot-nav-item">
                        <mat-list-item>SWOT</mat-list-item>
                    </a>
                    <a (click)="scrollToComponent('comparable-companies')" data-test="comparable-companies-nav-item">
                        <mat-list-item>Comparable Companies</mat-list-item>
                    </a>
                }
                <a (click)="scrollToComponent('shareholder-structure')" data-test="shareholder-structure-nav-item">
                    <mat-list-item>Shareholder Structure</mat-list-item>
                </a>
                <a (click)="scrollToComponent('exit-information')" data-test="exit-information-nav-item">
                    <mat-list-item>Exit Information</mat-list-item>
                </a>
                <a (click)="scrollToComponent('gp-valuation')" data-test="gp-valuation-nav-item">
                    <mat-list-item>GP Valuation</mat-list-item>
                </a>
                <a (click)="scrollToComponent('fin-data-history')" data-test="fin-data-history-nav-item">
                    <mat-list-item>Financial Data History</mat-list-item>
                </a>
                <a (click)="scrollToComponent('developments-since-investment')" data-test="developments-since-investment-nav-item">
                    <mat-list-item>Developments Since Investment</mat-list-item>
                </a>
                @if ((sourceDataset$ | async) === 'master' && (isRealized$ | async) === false) {
                    <a (click)="scrollToComponent('asset-valuation-forecast')" data-test="asset-valuation-forecast-nav-item">
                        <mat-list-item>Company Valuation (Forecast)</mat-list-item>
                    </a>
                }
                <a (click)="scrollToComponent('documents')" data-test="documents-nav-item">
                    <mat-list-item>Documents</mat-list-item>
                </a>
            </mat-action-list>
        </div>
    </mat-sidenav>
    <mat-sidenav-content>
        @if (!sidenav.opened) {
            <div class="top-left-nav-toggle">
                <button (click)="sidenav.toggle()" color="primary" mat-icon-button>
                    <mat-icon>menu</mat-icon>
                </button>
            </div>
        }
        @if (selectedAsset$ | async; as selectedAsset) {
            <div class="breadcrumb-container">
                <label class="breadcrumb" data-test="breadcrumb">
                    @if (relatedDeal$ | async; as deal) {
                        @if (!!deal.id) {
                            <mat-icon>work_history</mat-icon>
                            <a [routerLink]="'../../deals/' + deal.id">{{ deal.name ?? '' }}</a>
                            <mat-icon>chevron_right</mat-icon>
                        }
                    }
                    @if (fundBreadcrumbData$ | async; as breadcrumb) {
                        @if (!!breadcrumb.fund?.id) {
                            <mat-icon>domain</mat-icon>
                            <a [queryParams]="{
                               fundReportId : fundReportId,
                               fundValuationId : fundValuationId,
                               dealId: breadcrumb.deal?.id}"
                               [routerLink]="'../../funds/' + breadcrumb.fund?.id"
                            >{{ breadcrumb.fund?.name ?? '' }}</a>
                            <mat-icon>chevron_right</mat-icon>
                        }
                    }
                    @if (relatedAssetsInFund$ | async; as relatedAssetsInFunds) {
                        @if (!!relatedAssetsInFunds && relatedAssetsInFunds.length > 0) {
                            <mat-icon>factory</mat-icon>
                            <select (change)="navigateTo($event.target)">
                                @for (investment of relatedAssetsInFunds; track investment) {
                                    <option
                                        [selected]="investment.id === selectedAsset.data.id"
                                        [ngClass]="{ 'realized': investment.realized }"
                                        [value]="investment.id">
                                        @if (investment.realized) {
                                            &nbsp;&nbsp;{{ investment.name }}
                                        } @else {
                                            {{ investment.name }}
                                        }
                                    </option>
                                }
                            </select>
                        }
                        @if (!relatedAssetsInFunds || relatedAssetsInFunds.length === 0) {
                            <mat-icon>factory</mat-icon>
                            {{ name | traceableFormat }}
                        }
                    }
                </label>
                @if ((sourceDataset$ | async) === 'master') {
                    <div class="detail-page-top-right-menu">
                        <button mat-icon-button class="menu-button"
                                [matMenuTriggerFor]="assetMenu"
                                aria-label="More options"
                                (click)="onAssetMenuButtonClick($event)">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #assetMenu="matMenu">
                            <button mat-menu-item (click)="openArchiveConfirmation(!selectedAsset.data.isArchived.value)">
                                <mat-icon>{{ selectedAsset.data.isArchived.value ? 'unarchive' : 'archive' }}</mat-icon>
                                <span>{{ selectedAsset.data.isArchived.value ? 'Unarchive' : 'Archive' }}</span>
                            </button>
                            <button mat-menu-item (click)="openDocumentGeneratorDialog()">
                                <mat-icon>article_shortcut</mat-icon>
                                <span>Generate Document</span>
                            </button>
                        </mat-menu>
                    </div>
                }
            </div>
            <div class="page-content">
                <form [formGroup]="nameForm">
                    <div class="detail-page-header">
                        <div>
                            @if (!assetNameIsEditable) {
                                <h1 data-test="asset-name"
                                    title="Last modified: {{name.modDate | timestamp}}">{{ name | traceableFormat }}</h1>
                            }
                            @if (assetNameIsEditable) {
                                <mat-form-field appearance="fill">
                                    <input data-test="asset-name-input"
                                           formControlName="assetName"
                                           matInput
                                           placeholder="Company Name">
                                </mat-form-field>
                            }
                        </div>
                        <div class="name-actions">
                            @if (!assetNameIsEditable) {
                                <button (click)="editMode()" [disabled]="(isEditDisabled$ | async)!" color="primary" data-test="edit-button"
                                        mat-icon-button>
                                    <mat-icon>edit</mat-icon>
                                </button>
                            }
                            @if (assetNameIsEditable) {
                                <button (click)="save()" [disabled]="nameForm.invalid" color="primary" data-test="save-button" mat-icon-button>
                                    <mat-icon>save</mat-icon>
                                </button>
                            }
                            @if (assetNameIsEditable) {
                                <button (click)="cancel()" color="primary" data-test="cancel-button" mat-icon-button>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            }
                            @if (selectedAsset.data.isArchived.value) {
                                <mat-chip
                                    class="archived"
                                    [disableRipple]="true"
                                    matTooltip="{{selectedAsset.data.isArchived.modDate | date}}">
                                    <mat-icon matChipAvatar>inventory_2</mat-icon>
                                    <span>Archived</span>
                                </mat-chip>
                            }
                        </div>
                        @let assetReportDate = (reportDate$ | async) ?? undefined;
                        @let assetClosingDate = (closingDate$ | async) ?? undefined;
                        @let assetValuationDescription = (fundValuationDescription$ | async)?.text;
                        <valumize-favorite-star
                            [favType]="'ASSET'"
                            [label]="name.text ?? ''"
                            [report]="assetReportDate?.date ? (assetReportDate | traceableFormat) : undefined"
                            [closingDate]="assetClosingDate?.date ? (assetClosingDate | traceableFormat) : undefined"
                            [valuation]="assetValuationDescription?.trim() || undefined">
                        </valumize-favorite-star>
                    </div>
                </form>
                @if ((sourceDataset$ | async) === 'master') {
                    <div class="component-wrapper">
                        <valumize-asset-description class="component" id="description"></valumize-asset-description>
                        <valumize-news class="component" id="news"
                                       [label]="selectedAsset.data.name.text"
                                       [context]="'asset/' + selectedAsset.data.id"
                                       [showImages]="false">
                        </valumize-news>
                    </div>
                }
                <valumize-asset-general-information id="general-information"></valumize-asset-general-information>
                @if ((sourceDataset$ | async) === 'master') {
                    <valumize-asset-end-markets-customers id="end-markets-customers"></valumize-asset-end-markets-customers>
                    <valumize-asset-swot id="swot"></valumize-asset-swot>
                    <valumize-asset-comparable-companies id="comparable-companies"></valumize-asset-comparable-companies>
                }
                <div class="component-wrapper">
                    <valumize-asset-shareholder-structure class="component-narrow" id="shareholder-structure"></valumize-asset-shareholder-structure>
                    <valumize-asset-exit-information class="component-wide" id="exit-information"></valumize-asset-exit-information>
                </div>
                <valumize-asset-gp-valuation id="gp-valuation"></valumize-asset-gp-valuation>
                <valumize-asset-fin-data-history id="fin-data-history"></valumize-asset-fin-data-history>
                <!-- Rendered unconditionally: hiding it made every past report's entry unreachable
                     once an investment was realized or the asset was opened in a dataset. The card
                     gates its own edit button instead (selectIsDevelopmentsSinceInvestmentEditDisabled).
                     The history itself is loaded by this page, shared with the Financial History
                     card's Commentary tab. -->
                <valumize-asset-developments-since-investment id="developments-since-investment"></valumize-asset-developments-since-investment>
                @if ((sourceDataset$ | async) === 'master' && (isRealized$ | async) === false) {
                    <valumize-asset-valuation-forecast [assetId]="assetId" [fundId]="fundId" [fundReportId]="fundReportId" [fundValuationId]="fundValuationId" id="asset-valuation-forecast"></valumize-asset-valuation-forecast>
                }
                <valumize-document id="documents" [context]="'/portfolio/assets/' + assetId + '/'"></valumize-document>
                <br/>
                <br/>
                <br/>
            </div>
        }
    </mat-sidenav-content>
</mat-sidenav-container>
